// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-7eb30353] .plaintext>span{margin-top:-7px}", ""]);
// Exports
module.exports = exports;
